var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "core-js/modules/es6.regexp.to-string", "core-js/modules/es6.date.to-string", "core-js/modules/es6.object.to-string", "@babel/runtime-corejs2/core-js/reflect/construct", "@babel/runtime-corejs2/helpers/extends", "@babel/runtime-corejs2/helpers/classCallCheck", "@babel/runtime-corejs2/helpers/createClass", "@babel/runtime-corejs2/helpers/assertThisInitialized", "@babel/runtime-corejs2/helpers/inherits", "@babel/runtime-corejs2/helpers/possibleConstructorReturn", "@babel/runtime-corejs2/helpers/getPrototypeOf", "@babel/runtime-corejs2/helpers/defineProperty", "prop-types", "react", "debounce", "emotion-theming", "../../themes", "../../Presse/TeaserMain/TeaserMain", "../../UI/Icon/ArteVertical", "../../UI/TitlesElement/TitlesElement", "../../Sliders/Bullets/Bullets", "../../Sliders/HOC/withAutoSliding", "./HomeMainCarousel.css"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("core-js/modules/es6.regexp.to-string"), require("core-js/modules/es6.date.to-string"), require("core-js/modules/es6.object.to-string"), require("@babel/runtime-corejs2/core-js/reflect/construct"), require("@babel/runtime-corejs2/helpers/extends"), require("@babel/runtime-corejs2/helpers/classCallCheck"), require("@babel/runtime-corejs2/helpers/createClass"), require("@babel/runtime-corejs2/helpers/assertThisInitialized"), require("@babel/runtime-corejs2/helpers/inherits"), require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"), require("@babel/runtime-corejs2/helpers/getPrototypeOf"), require("@babel/runtime-corejs2/helpers/defineProperty"), require("prop-types"), require("react"), require("debounce"), require("emotion-theming"), require("../../themes"), require("../../Presse/TeaserMain/TeaserMain"), require("../../UI/Icon/ArteVertical"), require("../../UI/TitlesElement/TitlesElement"), require("../../Sliders/Bullets/Bullets"), require("../../Sliders/HOC/withAutoSliding"), require("./HomeMainCarousel.css"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.es6Regexp, global.es6Date, global.es6Object, global.construct, global._extends, global.classCallCheck, global.createClass, global.assertThisInitialized, global.inherits, global.possibleConstructorReturn, global.getPrototypeOf, global.defineProperty, global.propTypes, global.react, global.debounce, global.emotionTheming, global.themes, global.TeaserMain, global.ArteVertical, global.TitlesElement, global.Bullets, global.withAutoSliding, global.HomeMainCarousel);
    global.HomeMainCarousel = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _es6Regexp, _es6Date, _es6Object, _construct, _extends2, _classCallCheck2, _createClass2, _assertThisInitialized2, _inherits2, _possibleConstructorReturn2, _getPrototypeOf2, _defineProperty2, _propTypes, _react, _debounce, _emotionTheming, _themes, _TeaserMain, _ArteVertical, _TitlesElement, _Bullets, _withAutoSliding, _HomeMainCarousel) {
  "use strict";

  var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

  var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

  _Object$defineProperty(_exports, "__esModule", {
    value: true
  });

  _exports.default = void 0;
  _construct = _interopRequireDefault(_construct);
  _extends2 = _interopRequireDefault(_extends2);
  _classCallCheck2 = _interopRequireDefault(_classCallCheck2);
  _createClass2 = _interopRequireDefault(_createClass2);
  _assertThisInitialized2 = _interopRequireDefault(_assertThisInitialized2);
  _inherits2 = _interopRequireDefault(_inherits2);
  _possibleConstructorReturn2 = _interopRequireDefault(_possibleConstructorReturn2);
  _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf2);
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _propTypes = _interopRequireDefault(_propTypes);
  _react = _interopRequireWildcard(_react);
  _debounce = _interopRequireDefault(_debounce);
  _themes = _interopRequireDefault(_themes);
  _TeaserMain = _interopRequireDefault(_TeaserMain);
  _ArteVertical = _interopRequireDefault(_ArteVertical);
  _TitlesElement = _interopRequireDefault(_TitlesElement);
  _Bullets = _interopRequireDefault(_Bullets);
  _withAutoSliding = _interopRequireDefault(_withAutoSliding);

  function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

  function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

  var HomeMainCarousel = /*#__PURE__*/function (_PureComponent) {
    (0, _inherits2.default)(HomeMainCarousel, _PureComponent);

    var _super = _createSuper(HomeMainCarousel);

    function HomeMainCarousel() {
      var _this;

      (0, _classCallCheck2.default)(this, HomeMainCarousel);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onBulletClick", function (slideIndex) {
        var teaser = _this.root.querySelectorAll('.teaser-focus')[slideIndex];

        _this.props.injectedProp.onBulletClick(slideIndex, teaser);
      });
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onBulletPress", function (slideIndex) {
        var teaser = _this.root.querySelectorAll('.teaser-focus')[slideIndex];

        _this.props.injectedProp.onBulletPress(slideIndex, teaser);
      });
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "init", function (root) {
        _this.root = root;
      });
      return _this;
    }

    (0, _createClass2.default)(HomeMainCarousel, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var target = global.document.querySelector(_HomeMainCarousel.StyledWrapper);

        if (target) {
          this.onMouseLeaveDebounce = (0, _debounce.default)(this.props.injectedProp.unpauseAutoplay, 300);
          this.onMouseOverDebounce = (0, _debounce.default)(this.props.injectedProp.pauseAutoplay, 300);
          target.addEventListener('mouseleave', this.onMouseLeaveDebounce);
          target.addEventListener('mouseover', this.onMouseOverDebounce);
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        var target = global.document.querySelector(_HomeMainCarousel.StyledWrapper);

        if (target) {
          target.removeEventListener('mouseleave', this.onMouseLeaveDebounce);
          target.removeEventListener('mouseover', this.onMouseOverDebounce);
          this.onMouseLeaveDebounce.clear();
          this.onMouseOverDebounce.clear();
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props = this.props,
            injectedProp = _this$props.injectedProp,
            labels = _this$props.labels,
            theme = _this$props.theme,
            teasers = _this$props.teasers;
        return /*#__PURE__*/_react.default.createElement(_emotionTheming.ThemeProvider, {
          theme: _themes.default[theme]
        }, /*#__PURE__*/_react.default.createElement(_HomeMainCarousel.StyledWrapper, {
          onMouseLeave: this.onMouseLeaveDebounce,
          onMouseOver: this.onMouseOverDebounce,
          onTouchStart: injectedProp.touchStart,
          onTouchEnd: injectedProp.touchEnd
        }, /*#__PURE__*/_react.default.createElement("h2", {
          className: "sr-only"
        }, labels.mainSliderLabel), /*#__PURE__*/_react.default.createElement(_HomeMainCarousel.StyledLogo, null, /*#__PURE__*/_react.default.createElement(_ArteVertical.default, {
          size: {
            default: 'small',
            medium: 'medium',
            large: 'large'
          }
        })), teasers.length > 0 && /*#__PURE__*/_react.default.createElement(_Bullets.default, {
          autoplay: injectedProp.autoplay,
          labels: labels,
          onBulletClick: this.onBulletClick,
          onBulletNavigate: injectedProp.onBulletNavigate,
          onBulletPress: this.onBulletPress,
          pause: injectedProp.pauseAutoplay,
          slideIndex: injectedProp.slideIndex,
          teasers: teasers,
          togglePlayButton: injectedProp.togglePlayButton
        }), /*#__PURE__*/_react.default.createElement("div", {
          ref: this.init
        }, teasers.map(function (teaserProps, teaserIndex) {
          var isActive = injectedProp.slideIndex === teaserIndex;
          return /*#__PURE__*/_react.default.createElement(_HomeMainCarousel.StyledSlide, {
            isActive: isActive,
            key: teaserProps.id
          }, /*#__PURE__*/_react.default.createElement(_TeaserMain.default, (0, _extends2.default)({
            mouseFocus: injectedProp.mouseFocus,
            pause: injectedProp.pauseAutoplay,
            unpause: injectedProp.unpauseAutoplay,
            titlesElement: /*#__PURE__*/_react.default.createElement(_TitlesElement.default, {
              isActive: isActive,
              display: "FULL",
              subtitle: teaserProps.subtitle,
              title: teaserProps.title
            }),
            tabIndex: isActive ? 0 : -1
          }, teaserProps, {
            title: ""
          })));
        }))));
      }
    }]);
    return HomeMainCarousel;
  }(_react.PureComponent);

  HomeMainCarousel.propTypes = {
    injectedProp: _propTypes.default.shape().isRequired,
    labels: _propTypes.default.shape({
      active: _propTypes.default.string,
      display: _propTypes.default.string,
      mainSliderLabel: _propTypes.default.string,
      pause: _propTypes.default.string,
      play: _propTypes.default.string
    }).isRequired,
    teasers: _propTypes.default.arrayOf(_propTypes.default.shape()).isRequired,
    theme: _propTypes.default.string.isRequired
  };

  var _default = (0, _withAutoSliding.default)(HomeMainCarousel);

  _exports.default = _default;
});